module.exports = __webpack_public_path__ + "img/lx-img4.a7a696c0.png";